import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 0 8px 0',
  },
  tagChip: {
    lineHeight: '8px',
    padding: '8px',
    marginRight: '10px',
    marginBottom: '5px',
    borderRadius: '25px',
    fontSize: '0.7rem',
    fontWeight: 500,
  },
  tagChipMedium: {
    fontSize: '0.8rem !important',
  },
}), { name: 'tags' });
